import type { TAddress } from 'api/models/TAddress';
import type { TProduct } from 'api/models/TProduct';

export enum QuoteLeadStatus {
  NEW = 'New',
  INPROGRESS = 'InProgress',
  COMPLETE = 'Complete',
  RETURNED = 'Returned',
  RETURNINPROGRESS = 'ReturnInProgress',
  RETURNCOMPLETE = 'ReturnComplete'
}

type CustomerDetails = {
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
};

export type TQuoteLead = {
  channel?: 'Direct Sales';
  status: QuoteLeadStatus;
  journey?: {
    journeyURL: string;
    electricityConsumption?: number;
    gasConsumption?: number;
    MPRN?: string;
    MPAN?: string;
    postCode: string;
    meterType: string;
    isTOU: boolean;
    isEconomy7: boolean;
    fuel: string;
    paymentOption: string;
    tariffType: string;
    currentAddress: TAddress;
  };
  products?: TProduct[];
  customerDetails?: CustomerDetails;
  updatedTimeStamp?: string;
  createdTimeStamp?: string;
};

export type TPostQuoteLeadResponse = {
  encryptedID: string;
};
